import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Radar = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M30 15C30 15.552 29.552 16 29 16C28.448 16 28 15.552 28 15C28 14.448 28.448 14 29 14C29.552 14 30 14.448 30 15Z" />
		<path d="M16 8C11.589 8 8.00001 11.589 8.00001 16C8.00001 20.411 11.589 24 16 24H17C17.552 24 18 23.552 18 23C18 22.448 17.552 22 17 22H16C12.691 22 10 19.308 10 16C10 12.692 12.691 10 16 10C17.264 10 18.468 10.39 19.476 11.11L15.293 15.293C14.903 15.684 14.903 16.317 15.293 16.707C15.488 16.902 15.744 17 16 17C16.256 17 16.512 16.902 16.707 16.707L27.707 5.707C28.097 5.316 28.097 4.683 27.707 4.293C27.317 3.903 26.683 3.903 26.293 4.293L25.168 5.418C22.623 3.207 19.405 2 16.001 2C8.28101 2 2.00101 8.28 2.00101 16C2.00101 23.72 8.28101 30 16.001 30H17.001C17.553 30 18.001 29.552 18.001 29C18.001 28.448 17.553 28 17.001 28H16.001C9.38401 28 4.00101 22.617 4.00101 16C4.00101 9.383 9.38401 4 16.001 4C18.871 4 21.586 5.001 23.75 6.837L20.906 9.681C19.509 8.592 17.801 8 16.002 8H16Z" />
		<path d="M23.001 28C22.671 28 22.349 27.837 22.158 27.539C21.86 27.074 21.996 26.455 22.461 26.158C24.507 24.848 26.148 22.881 27.084 20.618C27.295 20.108 27.88 19.865 28.39 20.076C28.9 20.287 29.143 20.872 28.932 21.382C27.826 24.058 25.961 26.292 23.539 27.842C23.372 27.949 23.185 28 23.001 28V28Z" />
		<path d="M23 16C22.448 16 22 16.448 22 17C22 18.008 21.378 19.208 20.293 20.293C20.112 20.474 20 20.724 20 21C20 21.552 20.448 22 21 22C21.276 22 21.526 21.888 21.707 21.707C22.563 20.851 24 19.1 24 17C24 16.448 23.552 16 23 16Z" />
	</svg>
);

export default Radar;
